import { useEffect, useState } from 'react';
import { Box, Button, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { CaseIcon } from 'src/icons/CaseIcon';
import IntentService from 'src/services/IntentService';

import type { Workspace } from 'src/services/IntentService';

export default function SetupDrafts({ currentId }: { currentId?: string | null }) {
    const [drafts, setDrafts] = useState<Workspace[]>([]);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let live = true;
        setError(false);
        IntentService.list()
            .then(({ workspaces }) => {
                if (live) setDrafts(workspaces.filter((item) => !item.streams.length && String(item.id) !== currentId));
            })
            .catch(() => {
                if (live) setError(true);
            });
        return () => {
            live = false;
        };
    }, [currentId, attempt]);

    if (!drafts.length && !error) return null;

    return (
        <Box
            component="details"
            sx={{ mb: 3, color: 'var(--lm-text)' }}
        >
            <Box
                component="summary"
                sx={{ cursor: 'pointer', py: 1, fontSize: 14, width: 'fit-content' }}
            >
                Продолжить настройку{drafts.length > 0 ? ` (${drafts.length})` : ''}
            </Box>
            {error ? (
                <Box role="alert">
                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        Не удалось загрузить черновики.
                    </Typography>
                    <Button onClick={() => setAttempt((value) => value + 1)}>Повторить</Button>
                </Box>
            ) : (
                <List
                    dense
                    disablePadding
                    aria-label="Незавершённые настройки потоков"
                >
                    {drafts.map((draft) => (
                        <ListItemButton
                            key={draft.id}
                            component={Link}
                            to={'/leadstream?draft=' + encodeURIComponent(draft.id)}
                            sx={{ borderRadius: 1, minHeight: 44, px: 1.25 }}
                        >
                            <ListItemIcon sx={{ minWidth: 32, color: 'var(--lm-muted)' }}>
                                <CaseIcon />
                            </ListItemIcon>
                            <ListItemText primary={draft.name || 'Без названия'} />
                        </ListItemButton>
                    ))}
                </List>
            )}
        </Box>
    );
}
